import SiteHeader from "@/components/SiteHeader";

export default function Privacy() {
  return (
    <div className="bg-cream text-navy min-h-screen" data-testid="privacy-page">
      <SiteHeader />
      <article className="max-w-3xl mx-auto px-6 md:px-10 py-16 prose prose-navy">
        <div className="overline text-gold-deep mb-4">Privacy</div>
        <h1 className="editorial-h1 text-4xl md:text-5xl text-navy">Privacy &amp; cookies.</h1>
        <div className="gold-rule mt-6 mb-10" />

        <h2 className="font-serif text-2xl text-navy mt-10">What we collect</h2>
        <p className="text-navy/80 font-light leading-relaxed mt-3">
          This site is operated personally by Joseph Poche. We collect only what is necessary:
        </p>
        <ul className="mt-3 space-y-2 text-navy/80 font-light">
          <li>— <strong>Contact-form submissions</strong>: name, email, organization and message you send via the contact page or expert-consultation page.</li>
          <li>— <strong>Anonymous analytics</strong> (PostHog) — page views and aggregate behaviour, with opt-out via the cookie banner.</li>
          <li>— <strong>Authentication cookies</strong> (only when signing in to the private CRM): httpOnly, secure access &amp; refresh tokens. Essential — not optional.</li>
        </ul>

        <h2 className="font-serif text-2xl text-navy mt-10">Cookies in use</h2>
        <ul className="mt-3 space-y-2 text-navy/80 font-light">
          <li>— <strong>access_token / refresh_token</strong> — strictly necessary, set only on private CRM sign-in. httpOnly, SameSite=Lax.</li>
          <li>— <strong>jp_cookie_consent_v1</strong> (localStorage) — remembers your cookie choice on this device.</li>
          <li>— <strong>PostHog cookies</strong> — only set after you press <em>Accept</em>.</li>
        </ul>

        <h2 className="font-serif text-2xl text-navy mt-10">Payments</h2>
        <p className="text-navy/80 font-light leading-relaxed mt-3">
          Paid Expert Consultation requests use <strong>Stripe Checkout</strong>. We do not store card details — Stripe handles all
          payment data under PCI-DSS. We retain only the session ID, status and amount for our records.
        </p>

        <h2 className="font-serif text-2xl text-navy mt-10">Your rights</h2>
        <p className="text-navy/80 font-light leading-relaxed mt-3">
          You may request access, correction or deletion of any personal data we hold by emailing
          {" "}<a className="underline decoration-gold underline-offset-4" href="mailto:josephpoche13@gmail.com">josephpoche13@gmail.com</a>.
          We respond within 14 days.
        </p>

        <h2 className="font-serif text-2xl text-navy mt-10">Data sharing</h2>
        <p className="text-navy/80 font-light leading-relaxed mt-3">
          We do not sell personal data. Sub-processors used: PostHog (analytics, opt-in only), Stripe (payments),
          Resend (email delivery) and our infrastructure host (hosting &amp; AI/object storage). All are bound by their own privacy terms.
        </p>

        <p className="text-xs text-navy/50 mt-12">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long" })}.</p>
      </article>

      <footer className="bg-navy text-cream/70 py-12">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-xs">© {new Date().getFullYear()} Joseph Poche</div>
      </footer>
    </div>
  );
}
